/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Needs_ReviewInputs */

const en_editor_filter_needs_review = /** @type {(inputs: Editor_Filter_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs Review`)
};

const fr_editor_filter_needs_review = /** @type {(inputs: Editor_Filter_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À réviser`)
};

const de_editor_filter_needs_review = /** @type {(inputs: Editor_Filter_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfung erforderlich`)
};

const it_editor_filter_needs_review = /** @type {(inputs: Editor_Filter_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da revisionare`)
};

const ru_editor_filter_needs_review = /** @type {(inputs: Editor_Filter_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требует проверки`)
};

const es_editor_filter_needs_review = /** @type {(inputs: Editor_Filter_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requiere revisión`)
};

const zh_cn2_editor_filter_needs_review = /** @type {(inputs: Editor_Filter_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需审核`)
};

const ja_editor_filter_needs_review = /** @type {(inputs: Editor_Filter_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`要確認`)
};

const hi_editor_filter_needs_review = /** @type {(inputs: Editor_Filter_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा आवश्यक`)
};

const pt_pt2_editor_filter_needs_review = /** @type {(inputs: Editor_Filter_Needs_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necessita Revisão`)
};

/**
* | output |
* | --- |
* | "Needs Review" |
*
* @param {Editor_Filter_Needs_ReviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_needs_review = /** @type {((inputs?: Editor_Filter_Needs_ReviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Needs_ReviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_needs_review(inputs)
	if (locale === "de") return de_editor_filter_needs_review(inputs)
	if (locale === "it") return it_editor_filter_needs_review(inputs)
	if (locale === "ru") return ru_editor_filter_needs_review(inputs)
	if (locale === "es") return es_editor_filter_needs_review(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_needs_review(inputs)
	if (locale === "ja") return ja_editor_filter_needs_review(inputs)
	if (locale === "hi") return hi_editor_filter_needs_review(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_needs_review(inputs)
	return en_editor_filter_needs_review(inputs)
});